export function invalidPhone(val: string): boolean {
  return !(val.length !== 0 && (!/^\+\d+$/.test(val) || val.length < 7))
}

export function formatAndValidatePhoneNumber(
  value: string | undefined,
): string | undefined {
  if (!value) {
    return undefined
  }
  const cleaned = value.replace(/[^\d+]/g, '')
  const formatted = cleaned.startsWith('+')
    ? '+' + cleaned.substring(1).replace(/\+/g, '')
    : cleaned.replace(/\+/g, '')

  return formatted.length <= 15 ? formatted : formatted.substring(0, 15)
}
